<template>

  <HeaderSection />

  <section id="formulario" class="min-h-screen">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700 mx-5"
      @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto max-w-7xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl">

        <h1 class="font-bold text-center text-lg md:text-2xl">{{ $t('titulo.acreditacion.invitados') }}</h1>
        <h1 class="font-bold text-center text-sm md:text-xl">{{ $t('label.complete.el.form') }}</h1>


        <!-- Estado de acreditado -->
        <div v-if="estadoAcreditadoExistente !== 'loading' && estadoAcreditadoExistente === 'no-existe'">
          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
            <div class="w-full px-2 bg-blue-300 rounded-lg shadow-lg p-4 text-center font-bold text-white text-2xl">
              NUEVO
            </div>
          </div>
        </div>
        <div v-if="estadoAcreditadoExistente !== 'loading' && estadoAcreditadoExistente === 'existe'">
          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
            <div class="w-full px-2  rounded-lg shadow-lg p-4 text-center font-bold text-white text-2xl"
              :class="{ 'bg-indigo-400': acreditado.estadoAcreditado.id === 1, 'bg-green-400': acreditado.estadoAcreditado.id === 2, 'bg-red-400': acreditado.estadoAcreditado.id === 3 }">
              {{
                acreditado.estadoAcreditado.id === 1 ? $t('estado.pendiente') :
                  acreditado.estadoAcreditado.id === 2 ? $t('estado.verificado') :
                    acreditado.estadoAcreditado.id === 3 ? $t('estado.rechazado') : ''
              }}
            </div>
          </div>
        </div>

        <!-- Fin Estado de acreditado -->

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">{{ $t('label.documento') }}</label>
            <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
              <InputText v-bind="field" type="text" readonly="true" class="input-base"
                :placeholder="$t('label.documento')"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="dni" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-8/12">
            <label class="block mb-1">{{ $t('label.tipo.acreditado') }}</label>
            <Field name="tipoAcreditado" v-slot="{ handleChange, handleBlur, value, errors }"
              v-model="formData.tipoAcreditado">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                :placeholder="$t('label.tipo.acreditado')" class="input-base" :options="tiposAcreditados"
                optionLabel="descripcion"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="tipoAcreditado" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">{{ $t('label.nombre') }}</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.nombre')"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="nombre" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">{{ $t('label.apellido') }}</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.apellido')"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="apellido" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
          <div class="w-full px-2 md:w-5/12">
            <label class="block mb-1">{{ $t('label.empresa') }}</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.empresa')"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="empresa" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">{{ $t('label.cargo') }}</label>
            <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.cargo')"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="cargo" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">{{ $t('label.cuit') }}</label>
            <Field name="cuit" v-slot="{ field, errors }" v-model="formData.cuit">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.cuit')"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="cuit" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">{{ $t('label.pais') }}</label>
            <Select v-model="selectedCountry" :options="translatedCountries" optionLabel="value"
              :placeholder="$t('label.pais')" class="input-base" />
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">{{ $t('label.codigo.pais') }}</label>
            <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.code" class="input-base"
              readonly />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">{{ $t('label.codigo.area') }}</label>
            <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.codigo.area')"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="codigoArea" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">{{ $t('label.celular') }}</label>
            <Field name="numeroTelefono" v-slot="{ field, errors }" v-model="formData.numeroTelefono">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.celular')"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="numeroTelefono" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">{{ $t('label.mail') }}</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" class="input-base" :placeholder="$t('label.mail')"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="mail" />
              </span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">{{ $t('label.website') }}</label>
            <Field name="webSite" v-slot="{ field, errors }" v-model="formData.webSite">
              <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.website')"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="webSite" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">{{ $t('label.pais.residencia') }}</label>
            <Field name="paisDomicilio" v-slot="{ handleChange, handleBlur, value, errors }"
              v-model="formData.paisDomicilio">
              <Select filter @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }"
                placeholder="País" class="input-base" :options="translatedResidenceCountries" optionLabel="value" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="paisDomicilio" />
              </span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisDomicilio?.code == '+54'">
            <label class="block mb-1">{{ $t('label.provincia') }}</label>
            <Field name="provincia" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.provincia">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                :placeholder="$t('errors.seleccione.opcion')" :options="provincias" optionLabel="descripcion"
                class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="provincia" />
              </span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisDomicilio?.code != '+54'">
            <label class="block mb-1">{{ $t('label.provincia') }}</label>
            <Field name="provinciaEstado" v-slot="{ field, errors }" v-model="formData.provinciaEstado">
              <InputText v-bind="field" type="text" placeholder="Ingrese su provincia o estado" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="provinciaEstado" />
              </span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisDomicilio?.code == '+54'">
            <label class="block mb-1">{{ $t('label.localidad') }}</label>
            <Field name="localidad" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.localidad">
              <Select @blur="handleBlur" filter @update:model-value="handleChange" :model-value="value"
                :placeholder="$t('errors.seleccione.opcion')" class="input-base" :options="localidades"
                optionLabel="descripcion"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="localidad" />
              </span>
            </Field>
          </div>

          <div class="w-full px-2 md:w-4/12" v-if="formData.paisDomicilio?.code != '+54'">
            <label class="block mb-1">{{ $t('label.localidad') }}</label>
            <Field name="localidadCiudad" v-slot="{ field, errors }" v-model="formData.localidadCiudad">
              <InputText v-bind="field" type="text" placeholder="Ingrese su localidad o ciudad" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="localidadCiudad" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
          <div class="w-full px-2">
            <label class="block mb-1">{{ $t('label.rubros') }}</label>
            <Field name="rubros" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.rubros">
              <MultiSelect @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                :options="rubrosList" optionLabel="descripcion" :placeholder="$t('label.rubros')" :showToggleAll="false"
                class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="rubros" />
              </span>
            </Field>
          </div>
        </div>

        <!-- Gestión de clave de actualización cuando el acreditado NO existe-->
        <div v-if="estadoAcreditadoExistente !== 'loading' && estadoAcreditadoExistente === 'no-existe'">
          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
            <div class="w-full px-2">
              <label class="block mb-1">{{ $t('label.clave.actualizacion') }}</label>
              <Field name="claveActualizacion" v-slot="{ field, errors }" v-model="formData.claveActualizacion">
                <InputText v-bind="field" type="mail" class="input-base" :placeholder="$t('label.clave.actualizacion')"
                  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-sm text-red-500 p-error">
                  <ErrorMessage name="claveActualizacion" />
                </span>
              </Field>
            </div>
          </div>

          <div class="w-full mx-auto space-y-2 mt-2">
            <details class="group border rounded-lg p-3 bg-gray-50 shadow-md">
              <summary class="flex justify-between items-center cursor-pointer font-semibold list-none">
                {{ $t('label.detalle.clave.titulo') }}
                <span class="relative w-4 h-4">
                  <i class="pi pi-plus absolute inset-0 transition-opacity duration-200 group-open:opacity-0"></i>
                  <i
                    class="pi pi-minus absolute inset-0 opacity-0 transition-opacity duration-200 group-open:opacity-100"></i>
                </span>
              </summary>
              <div class="py-3 space-y-2 text-sm">
                <div class="text-gray-600">{{ $t('label.detalle.clave.linea1') }}</div>
                <div class="text-gray-600">{{ $t('label.detalle.clave.linea2') }}</div>
                <div class="text-gray-500">{{ $t('label.detalle.clave.linea3') }}</div>
              </div>
            </details>
          </div>
        </div>

        <!-- Gestión de cambio de clave de actualización cuando el acreditado SI existe-->
        <div class="mt-3" v-if="estadoAcreditadoExistente !== 'loading' && estadoAcreditadoExistente === 'existe'">
          <button @click="cambiarClave" type="button"
            class="px-4 py-2 bg-transparent border-[#243665] hover:bg-[#243665] text-[#243665] font-semibold hover:text-white border rounded-xl"
            :disabled="isSubmitting">
            <i class="pi pi-times mr-2"></i>
            {{ $t('boton.cambiar.clave') }}
          </button>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
          <div class="w-full px-2 flex flex-row gap-2">
            <ToggleSwitch v-model="formData.recibirNodedades" inputId="recibirNotificaciones" />
            <label for="recibirNotificaciones" class="cursor-pointer">{{ $t('label.acepto.recibir') }}</label>
          </div>
        </div>

        <div class="flex flex-wrap py-2 mt-8 space-x-2">
          <button type="submit"
            class="px-4 py-2 bg-transparent border-[#243665] hover:bg-[#243665] text-[#243665] font-semibold hover:text-white border rounded-xl"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i> {{ $t('boton.registrarme') }}
          </button>
          <button @click="salirCancelar" type="button"
            class="px-4 py-2 bg-transparent border-red-600 hover:bg-red-600 text-red-600 font-semibold hover:text-white border rounded-xl"
            :disabled="isSubmitting">
            <i class="pi pi-times mr-2"></i>
            {{ $t('boton.cancelar') }}
          </button>

        </div>
      </div>


    </Form>

  </section>

  <FooterSection />
  <CambiarPasswordView v-if="cambiarPasswordVisible" :closeFunction="cerrarDialogoCambiarPassword"
    :acreditado="acreditado" />
  <BlockUI :blocked="isSubmitting" />
</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import MultiSelect from 'primevue/multiselect';
import BlockUI from 'primevue/blockui';
import HeaderSection from '@/components/HeaderSection.vue'
import ToggleSwitch from 'primevue/toggleswitch';

import CambiarPasswordView from './modal/CambiarPasswordView.vue';

import suiteService, { Acreditado, OrigenAcreditado, EstadoAcreditado, TipoAcreditado, IdLabelEntity, StringIdLabelEntity } from 'qreventos-suite/services';

import { SAVE, ORIGEN_ACREDITADO, UPDATE, VERIFICADO, A_VERIFICAR, RECHAZADO } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';
import FooterSection from './FooterSection.vue';
import { fetchValidationRules, evaluarEstadoAcreditado } from '@/services/validationEngine';

interface Pais {
  code: string;
  value: string;
  descripcion: string;
}

interface Provincia extends IdLabelEntity { }
interface Localidad extends IdLabelEntity { }
interface Rubro extends StringIdLabelEntity { }

import jsonCountries from '@/data/countries.json';
import jsonProvincias from '@/data/provincias.json';
import jsonLocalidades from '@/data/localidades.json';
import jsonTiposAcredtados from '@/data/tiposAcreditados.json'
import jsonRubros from '@/data/rubros.json'

export default defineComponent({
  components: {
    HeaderSection, FooterSection,
    InputText, Select, ToggleSwitch, MultiSelect,
    Field, ErrorMessage, Form, BlockUI,
    CambiarPasswordView
  },
  data() {
    return {
      isSubmitting: false,
      paises: jsonCountries as Pais[],
      selectedCountry: { "code": "+54", "value": "pais.argentina", "descripcion": "Argentina" } as Pais,
      provincias: jsonProvincias as Provincia[],
      localidades: jsonLocalidades as Localidad[],
      tiposAcreditados: jsonTiposAcredtados as TipoAcreditado[],
      rubrosList: jsonRubros as Rubro[],
      acreditado: undefined as unknown as Acreditado,
      estadoAcreditadoExistente: 'loading' as 'loading' | 'existe' | 'no-existe',
      cambiarPasswordVisible: false,
      formData: {
        tipoAcreditado: undefined as unknown as TipoAcreditado,
        dni: '',
        nombre: '',
        apellido: '',
        empresa: '',
        cuit: '',
        cargo: '',
        webSite: '',
        mail: '',
        codigoArea: '',
        numeroTelefono: '',
        recibirNodedades: true,
        paisDomicilio: { code: "+54", value: "pais.argentina", descripcion: "Argentina" } as Pais,
        provincia: undefined as unknown as Provincia,
        provinciaEstado: '',
        localidad: undefined as unknown as Localidad,
        localidadCiudad: '',
        rubros: undefined as unknown as Rubro[],
        claveActualizacion: ''
      }
    };
  },
  watch: {
    translatedCountries: {
      immediate: true,
      handler(list) {
        if (!this.selectedCountry) { return; }
        const found = list.find((p: Pais) => p.code === this.selectedCountry.code);
        if (found) {
          this.selectedCountry = found
        }
      }
    },
    translatedResidenceCountries: {
      immediate: true,
      handler(list) {
        if (!this.formData.paisDomicilio) { return; }
        const found = list.find((p: Pais) => p.code === this.formData.paisDomicilio.code);
        if (found) {
          this.formData.paisDomicilio = found
        }
      }
    },
    'formData.provincia.id'(newValue) {
      if (newValue) {
        this.localidades = jsonLocalidades;
        this.localidades = this.localidades.filter((localidad: Localidad) => localidad.id === newValue);
      }
    },
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required(this.$t('errors.dni.required')).min(6, this.$t('errors.dni.min')),
        tipoAcreditado: yup.mixed().required(this.$t('errors.seleccione.opcion')),
        nombre: yup.string().required(this.$t('errors.name.required')).min(3, this.$t('errors.name.min')),
        apellido: yup.string().required(this.$t('errors.lastname.required')).min(3, this.$t('errors.lastname.min')),
        empresa: yup.string().required(this.$t('errors.empresa.required')).min(3, this.$t('errors.empresa.min')),
        cargo: yup.string().required(this.$t('errors.cargo.required')).min(3, this.$t('errors.cargo.min')),
        cuit: yup.string().required(this.$t('errors.cuit.required')).min(6, this.$t('errors.cuit.min')),
        codigoArea: yup.string().required(this.$t('errors.areaCode.required')).matches(/^\d+$/, this.$t('errors.areaCode.numeric')),
        numeroTelefono: yup.string().required(this.$t('errors.phone.required')).matches(/^\d+$/, this.$t('errors.phone.numeric')),
        mail: yup.string().required(this.$t('errors.email.required')).email(this.$t('errors.email.invalid')),
        webSite: yup.string().required(this.$t('errors.website.required')),
        rubros: yup.mixed().required(this.$t('errors.rubro.required')),

        claveActualizacion: yup.string().test('clave-condicional', this.$t('errors.clave.required'),
          (value) => {
            if (this.estadoAcreditadoExistente === 'no-existe') {
              return !!value && value.length >= 3;
            }
            return true;
          }
        ),

        provincia: yup.mixed().test('validacion-provincia-argentina', this.$t('errors.seleccione.opcion'), function (value) {
          const paisSelected = this.parent.paisDomicilio;
          if (paisSelected?.code == '+54' && !value) {
            return false;
          }
          return true;
        }),

        provinciaEstado: yup.string().test('validacion-provincia-otro', this.$t('errors.ingrese.provicia.estado'), function (value) {
          const paisSelected = this.parent.paisDomicilio;
          if (paisSelected?.code != '+54' && !value) {
            return false;
          }
          return true;
        }),

        localidad: yup.mixed().test('validacion-localidad-argentina', this.$t('errors.seleccione.opcion'), function (value) {
          const paisSelected = this.parent.paisDomicilio;
          if (paisSelected?.code == '+54' && !value) {
            return false;
          }
          return true;
        }),

        localidadCiudad: yup.string().test('validacion-localidad-otro', 'Ingrese la localidad/ciudad', function (value) {
          const paisSelected = this.parent.paisDomicilio;
          if (paisSelected?.code != '+54' && !value) {
            return false;
          }
          return true;
        }),
      });
    },
    translatedCountries() {
      return this.paises.map(pais => ({
        code: pais.code,
        value: this.$t(pais.value),
        descripcion: pais.descripcion
      }));
    },
    translatedResidenceCountries() {
      return this.paises.map(pais => ({
        code: pais.code,
        value: this.$t(pais.value),
        descripcion: pais.descripcion
      }));
    },
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: this.$t("error.revise") + " " + errores, icon: "error" });
    },
    async salirCancelar() {
      this.$router.push({ path: '/' });
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {

        if (!this.acreditado) {
          this.acreditado = {} as Acreditado;
          this.acreditado.modificado = SAVE;
        } else {
          this.acreditado.modificado = UPDATE;
        }


        if (this.acreditado.modificado === SAVE && this.formData.tipoAcreditado.id == 2240) {
          const preVal = evaluarEstadoAcreditado(this.formData);
          this.acreditado.estadoAcreditado = { id: preVal.estadoId } as EstadoAcreditado;
          this.acreditado.dato11 = preVal.estadoId.toString();
          this.acreditado.dato12 = preVal.motivo;

        }



        this.acreditado.tipoAcreditado = this.formData.tipoAcreditado;
        this.acreditado.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
        this.acreditado.dni = this.formData.dni;
        this.acreditado.nombre = this.formData.nombre;
        this.acreditado.apellido = this.formData.apellido;
        this.acreditado.empresa = this.formData.empresa;
        this.acreditado.cargo = this.formData.cargo;
        this.acreditado.dato1 = this.formData.cuit;
        this.acreditado.telefono = this.selectedCountry.code + this.formData.codigoArea + this.formData.numeroTelefono;
        this.acreditado.mail = this.formData.mail;
        this.acreditado.dato2 = this.formData.webSite;
        this.acreditado.passwd = this.formData.claveActualizacion;

        this.acreditado.dato4 = this.formData.paisDomicilio?.descripcion;
        console.log(this.formData.paisDomicilio.descripcion);
        console.log(this.acreditado.dato4);

        if (this.formData.paisDomicilio?.code == "+54") {
          this.acreditado.dato5 = this.formData.provincia?.descripcion;
          this.acreditado.dato6 = this.formData.localidad?.descripcion;
        } else {
          this.acreditado.dato5 = this.formData.provinciaEstado;
          this.acreditado.dato6 = this.formData.localidadCiudad;
        }

        this.acreditado.dato10 = this.selectedCountry.code;
        this.acreditado.dato8 = this.formData.codigoArea;
        this.acreditado.dato9 = this.formData.numeroTelefono;

        this.acreditado.dato3 = this.formData.rubros.map(rubro => rubro.descripcion).join(',');

        if (this.formData.recibirNodedades) {
          this.acreditado.dato7 = "SI";
        } else {
          this.acreditado.dato7 = "NO";
        }

        this.acreditado.cantidad = 1;
        this.acreditado.notificar = true;

        const acreditadoActualizado: Acreditado = await suiteService.saveOrUpdate(suiteConfig.evento, this.acreditado);
        if (acreditadoActualizado) {
          this.isSubmitting = false;
          this.confirmacion(this.acreditado.hash, acreditadoActualizado.estadoAcreditado.id);
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    async fillAcreditadoBy(hash: string) {
      this.acreditado = await suiteService.findAcreditadoByHash(suiteConfig.evento, hash);
      if (!this.acreditado) {
        Swal.fire({ title: this.$t('global.atencion'), html: this.$t('mensaje.acreditado.no.existe'), icon: "error" }).then(() => {
          this.$router.push({ path: '/' });
          return;
        });
      }

      this.estadoAcreditadoExistente = 'existe';

      this.acreditado.hash = hash;
      this.formData.dni = this.acreditado.dni;
      if (this.acreditado.tipoAcreditado) {
        this.formData.tipoAcreditado = this.tiposAcreditados.find(t => t.id === this.acreditado.tipoAcreditado.id) as TipoAcreditado;
      }
      this.formData.nombre = this.acreditado.nombre;
      this.formData.apellido = this.acreditado.apellido;
      this.formData.empresa = this.acreditado.empresa;
      this.formData.cargo = this.acreditado.cargo;
      this.formData.cuit = this.acreditado.dato1;

      this.formData.codigoArea = this.acreditado.dato8;
      this.formData.numeroTelefono = this.acreditado.dato9;

      this.formData.mail = this.acreditado.mail;
      this.formData.webSite = this.acreditado.dato2;
      //this.formData.claveActualizacion = this.acreditado.passwd;

      // También sincronizamos el combo de país del teléfono para que coincida la referencia
      const cpFound = (this.translatedCountries as Pais[]).find(p => p.code === this.acreditado.dato10);
      if (cpFound) {
        this.selectedCountry = cpFound;
      }

      const pFound = (this.translatedResidenceCountries as Pais[]).find(p => p.descripcion === this.acreditado.dato4);
      if (pFound) {
        this.formData.paisDomicilio = pFound;


        if (pFound.code == "+54") {
          const provFound = this.provincias.find(p => p.descripcion === this.acreditado.dato5);
          if (provFound) {
            this.formData.provincia = provFound as Provincia;
            const locFound = jsonLocalidades.find((l: any) => l.descripcion === this.acreditado.dato6);
            if (locFound) {
              this.formData.localidad = locFound as Localidad;
            }
          }
        } else {
          this.formData.provinciaEstado = this.acreditado.dato5;
          this.formData.localidadCiudad = this.acreditado.dato6;
        }
      }

      if (this.acreditado.dato3) {
        const descripts = this.acreditado.dato3.split(',');
        this.formData.rubros = this.rubrosList.filter(r => descripts.includes(r.descripcion));
      }

      if (this.acreditado.dato7 == "SI") {
        this.formData.recibirNodedades = true;
      } else {
        this.formData.recibirNodedades = false;
      }
    },
    async confirmacion(hash: string, idEstadoAcreditado: number) {

      // No verificado
      if (idEstadoAcreditado == A_VERIFICAR || idEstadoAcreditado == RECHAZADO) {
        Swal.fire({
          title: this.$t('global.atencion'),
          html: this.$t('mensaje.ya.acreditado.visitante'),
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: this.$t('global.salir'),
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.push({ path: '/' });
          }
        });

      } else if (idEstadoAcreditado == VERIFICADO) {
        Swal.fire({
          title: this.$t('global.atencion'),
          html: this.$t('mensaje.ya.acreditado.visitante'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t('global.salir'),
          cancelButtonText: this.$t('global.ver.credencial'),
          reverseButtons: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.push({ path: '/' });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$router.push({ path: '/credencial/' + hash }).then(() => { this.$router.go(0) });
          }
        });
      }
    },
    /**
     * Gestión de modal de cambio de password
     */
    cambiarClave() {
      this.cambiarPasswordVisible = true;
    },
    cerrarDialogoCambiarPassword(cambiada: boolean = false) {
      this.cambiarPasswordVisible = false;
      if (cambiada) {
        Swal.fire({ title: this.$t('global.atencion'), html: this.$t('mensaje.clave.cambiada'), icon: "success" });
      }
    },
    /**
     * Fin Gestión de modal de cambio de password
     */
  },
  async mounted() {
    this.estadoAcreditadoExistente = 'loading';

    fetchValidationRules().catch(err => console.warn('[PreValidación] Error al cargar reglas externas:', err));

    if (this.$route.params.dni) {
      this.formData.dni = this.$route.params.dni;
      this.estadoAcreditadoExistente = 'no-existe';
    }

    if (this.$route.params.hash) {
      this.isSubmitting = true;
      try {
        await this.fillAcreditadoBy(this.$route.params.hash);
        this.isSubmitting = false;
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  }
});
</script>